import Key from 'api/models/Engines/Key';

const dataToCopyTextMapper = (data: Key) => {
	return data;
};

export default dataToCopyTextMapper;
